import styled from "styled-components";
import { Link } from "react-router-dom";

const Footer = (props) => {
    return(
        <Container>
            <Content>
                <div className="footer-caption">
                    <h2 >Winnthako</h2>
                    <p>Having any financial difficulties in your business? Then you are in the right place. <b>Winnthako</b> offers great financial services ranging from consulting, management,loans, investment etc</p>
                    <span> Follow us : </span>
                </div>
                <div>
                    <header>Quick Links</header>
                    <ul>
                        <li><Link to ="/about">About</Link></li>
                        <li><Link to ="/help">Help(FAQ)</Link></li>
                        <li><Link to ="/blog">Blog</Link></li>
                        <li><Link to ="/contact">Contact</Link></li>
                    </ul>            
                </div>
                <div>
                    <header>Other Resources</header>
                    <ul>
                        <li><Link to ="/about">Support</Link></li>
                        <li><Link to ="/">Privacy Policy</Link></li>
                        <li><Link to ="/blog">Terms of Service</Link></li>
                        <li><Link to ="/contact">Business Loans</Link></li>
                        <li><Link to ="/services">Loan Services</Link></li>
                    </ul>
                </div>
                <div className="contact__us">
                    <header>Contact Us</header>
                    <span>Lower Benue, Makurdi Benue State, Nigeria</span><br/>
                    <span>winnthako@gmail.com</span><br/>
                    <span>+234 81 4802 9297</span>
                </div>
            </Content>
            <Copyright>
                Copyright &copy; 2022 Winnthako. Developed and designed by <span className="bold">Ayo Moses(08163647778)</span>
            </Copyright>
        </Container>
    )
}
const Copyright = styled.div`
    text-align: center;
    padding-top: 50px;
    font-size: 15px;
    color: rgb(96, 96, 96);

    .bold{
        color: rgb(255, 255, 255);
    }
`
const Container =  styled.div`
    background: rgb(17, 17, 17);
    color: rgb(255, 255, 255);
    padding: 50px 20px;

    @media(min-width: 768px){
        padding: 50px;
    }

    p{
        color: rgb(255, 255, 255);

        @media(min-width: 768px){
           font-size: 16px;
           font-weight: 400;
           line-height: 28.8px;

        }
    }
    ul{
        padding-left: 0;

        li{
            list-style-type: none;

            @media(min-width: 768px){

                margin-bottom: 20px;
            }
        
        }
    }
    
    a{
        color: rgb(255, 255, 255);
        font-size: 16px;
        font-weight: 400;
        transition: all 0.3s ease-in;
    }

    a:hover{
        color: rgb(231, 60, 62);
        font-weight: 500;
        font-size: 17px;
    }

`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid rgb(51, 53, 53);

    .footer-caption{
        margin-bottom: 20px;
    }

    header{
        font-size: 20px;
        font-family: 'Rubik', sans-serif;
        line-height: 24px;
        border-bottom: 1px solid rgb(51, 53, 53);
        padding-bottom: 20px;
        font-weight: 500;
    }
    .contact__us span{
        display: inline-block;
        margin: 20px 0;
    }
    @media(min-width: 768px){
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;

        div{
            width: 45%;
        }
    }
    @media(min-width: 1000px){
        div{
            width: 24%;
        }
    }
`

export default Footer